import { appendStatisticScripts, appendMarketingScripts, appendNecessaryScripts } from '../config/scripts';
import consentTypes from './consentTypes';

export default (selectedConsentTypes) => {
    const appendScript = (consentType) => {
        switch (consentType) {
            case consentTypes.CONSENT_TYPE_STATISTICS: appendStatisticScripts(); break;
            case consentTypes.CONSENT_TYPE_MARKETING: appendMarketingScripts(); break;
            case consentTypes.CONSENT_TYPE_NECESSARY: appendNecessaryScripts(); break;
            default: break;
        }
    };

    for (let i = 0; i < selectedConsentTypes.length; i += 1) {
        appendScript(selectedConsentTypes[i]);
        const consentType = `sfcookieconsent_${selectedConsentTypes[i]}`;
        const event = new CustomEvent(consentType,
            { detail: { consentType: selectedConsentTypes[i], selectedConsentTypes } });
        document.dispatchEvent(event);
    }

    const event = new CustomEvent('sfcookieconsent', { detail: { selectedConsentTypes } });
    document.dispatchEvent(event);
};
